<script setup>
import { Box } from '@aryeo/runway'
import { usePage } from '@inertiajs/vue3'
import { useAuth } from '@/Hooks/Company/useAuth.js'
import ImpersonationSessionManager from '@/Components/Company/PageWrapper/ImpersonationSessionManager.vue'
import PasswordExpirationBanner from '@/Components/Company/PageWrapper/PasswordExpirationBanner.vue'
import AryeoLite from '@/Components/Company/Organization/Banner/AryeoLite.vue'
import Breadcrumb from '@/Components/Company/PageWrapper/Breadcrumb.vue'
import SectionHeading from '@/Components/Shared/SectionHeading.vue'

const { authOrganization } = useAuth()
const page = usePage()
</script>

<template>
  <ImpersonationSessionManager />
  <PasswordExpirationBanner />

  <Box
    v-if="page.props.meta.breadcrumb && page.props.meta.breadcrumb.length > 0"
    borderBottom="small"
    borderColor="border-light"
  >
    <Breadcrumb />
  </Box>

  <div
    v-if="
      authOrganization &&
      !authOrganization?.is_pro_account &&
      !authOrganization?.aryeo_lite_learn_more_flag
    "
    style="max-width: 1368px"
    class="mx-auto"
  >
    <Box paddingTop="gutter" :paddingX="['medium', 'medium', 'gutter']">
      <AryeoLite />
    </Box>
  </div>

  <section style="max-width: 1368px" class="mx-auto">
    <Box paddingTop="gutter" :paddingX="['medium', 'medium', 'gutter']" paddingBottom="xxlarge">
      <SectionHeading />
      <slot />
    </Box>
  </section>
</template>
